import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20dc026c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ReplenishInfo" }
const _hoisted_2 = { class: "info block-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-tit" }, "协议详情", -1))
const _hoisted_4 = { class: "block-con" }
const _hoisted_5 = { class: "pics" }
const _hoisted_6 = { class: "uploader" }
const _hoisted_7 = { class: "self_flex_row self_justify_between self_align_center" }
const _hoisted_8 = { class: "self_flex_row self_align_center" }
const _hoisted_9 = { class: "image" }
const _hoisted_10 = { class: "file_type" }
const _hoisted_11 = { class: "type-rd" }
const _hoisted_12 = { style: {"font-size":"10px"} }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "submit-btn"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  class: "submit-btn"
}

import { ref, onMounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { flowsItem, projectItem, Approve } from '@/apis/base'
import { ImagePreview } from 'vant'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const state = reactive({
  suffixName: '',
  suffixSize: ''
})
const type_name = ref('--')
const pactDetails = ref({
  explain: '--', // 补充说明
  money: 0, // 补充合同金额（元）
  approve_state: 0, // 审批状态
  pics: null,
  attachment: '', // 合同附件
  name: '', // 附件名称
  size: '', // 附件大小
  type_id: 0, // 项目类型
  item_id: 0, // 详情id
  tabsActive: 0, // 已发起
  approve: {} as Approve,
  project: {} as projectItem,
  flows: Array<flowsItem>()
})
const StaffInfo = ref({
  id: 0,
  name: '',
  avatar: ''
})
const showBottom = ref(false)

const to_preview = () => {
  console.log(pactDetails.value.attachment)
  let suffixName = pactDetails.value.attachment.substring(pactDetails.value.attachment.lastIndexOf('.') + 1)
  if (suffixName == 'jpg' || suffixName == 'png' || suffixName == 'gif') {
    ImagePreview([pactDetails.value.attachment])
    return false
  }

  const link = document.createElement('a')
  link.href = pactDetails.value.attachment
  link.download = pactDetails.value.name
  link.click()
}

onMounted(() => {
  StaffInfo.value = JSON.parse(localStorage.getItem('STAFFINFO'))
  pactDetails.value = JSON.parse(router.currentRoute.value.query.data.toString())
  state.suffixName = pactDetails.value.attachment.substring(pactDetails.value.attachment.lastIndexOf('.') + 1)
  type_name.value = router.currentRoute.value.query.type_name.toString()
  let botton: any = router.currentRoute.value.query.button
  showBottom.value = botton
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_DetailTitle = _resolveComponent("DetailTitle")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_PreviewPicture = _resolveComponent("PreviewPicture")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_ApprovalProcess = _resolveComponent("ApprovalProcess")!
  const _component_BottomButtonTwo = _resolveComponent("BottomButtonTwo")!
  const _component_BottomButtonOne = _resolveComponent("BottomButtonOne")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_DetailTitle, {
      approve: pactDetails.value.approve
    }, null, 8, ["approve"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_cell_group, {
          title: "项目名称",
          border: false,
          class: "mx-box"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: pactDetails.value?.project?.name,
              size: "large"
            }, null, 8, ["title"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_cell_group, {
          title: "项目完结情况",
          border: false,
          class: "mx-box"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: "补充合同金额（元）",
              value: pactDetails.value.money
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "协议说明",
              value: pactDetails.value.explain
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        (pactDetails.value.pics)
          ? (_openBlock(), _createBlock(_component_van_cell_group, {
              key: 0,
              title: "图片",
              border: false
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_PreviewPicture, {
                    imgs: pactDetails.value.pics,
                    radius: 5,
                    width: 65,
                    height: 65
                  }, null, 8, ["imgs"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_van_cell_group, {
          title: "合同附件",
          border: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (_unref(state).suffixName == 'pdf' || _unref(state).suffixName == 'pptx' || _unref(state).suffixName == 'ppt')
                      ? (_openBlock(), _createBlock(_component_van_image, {
                          key: 0,
                          width: "40",
                          height: "40",
                          fit: "contain",
                          src: require('@/assets/project/pdf.png')
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    (_unref(state).suffixName == 'docx' || _unref(state).suffixName == 'doc')
                      ? (_openBlock(), _createBlock(_component_van_image, {
                          key: 1,
                          width: "40",
                          height: "40",
                          fit: "contain",
                          src: require('@/assets/project/word.png')
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    (_unref(state).suffixName == 'xlsx' || _unref(state).suffixName == 'xls')
                      ? (_openBlock(), _createBlock(_component_van_image, {
                          key: 2,
                          width: "40",
                          height: "40",
                          fit: "contain",
                          src: require('@/assets/project/excel.png')
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    (_unref(state).suffixName == 'jpeg' || _unref(state).suffixName == 'gif' || _unref(state).suffixName == 'png' || _unref(state).suffixName == 'jpg')
                      ? (_openBlock(), _createBlock(_component_van_image, {
                          key: 3,
                          width: "40",
                          height: "40",
                          fit: "contain",
                          src: require('@/assets/project/pisc.png')
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(pactDetails.value.name), 1),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(pactDetails.value.size), 1)
                  ])
                ]),
                _createElementVNode("div", {
                  class: "preview",
                  onClick: to_preview
                }, "预览")
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_ApprovalProcess, {
      flows: pactDetails.value.flows
    }, null, 8, ["flows"]),
    (pactDetails.value.tabsActive == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (pactDetails.value.approve.approve_staff?.id === StaffInfo.value.id && pactDetails.value.approve.state == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (showBottom.value)
                  ? (_openBlock(), _createBlock(_component_BottomButtonTwo, {
                      key: 0,
                      typeId: pactDetails.value.type_id,
                      itemId: pactDetails.value.item_id
                    }, null, 8, ["typeId", "itemId"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (pactDetails.value.tabsActive == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (pactDetails.value.approve.staff_id === StaffInfo.value.id && pactDetails.value.approve.state == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (showBottom.value)
                  ? (_openBlock(), _createBlock(_component_BottomButtonOne, {
                      key: 0,
                      typeId: pactDetails.value.type_id,
                      itemId: pactDetails.value.item_id
                    }, null, 8, ["typeId", "itemId"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})